import { Component, EventEmitter, Output, Input } from '@angular/core';
import {Common} from '../../shared/common';

@Component({
  selector: 'delete-user-popup',
  templateUrl: './delete-user-popup.component.html',
  styleUrls: ['./delete-user-popup.component.less', '../../shared/common.less']
})
export class DeleteUserPopupComponent {
  @Output() endDetailsPopup = new EventEmitter<boolean>();
  @Output() deleteEvent = new EventEmitter();
  @Input() contactToDelete: string = "";
  
  constructor(public common: Common) {}

  onDismiss(event: boolean) {
    this.endDetailsPopup.emit(event);
  }

  onDeleteEvent() {
    this.deleteEvent.emit();
  }

  ngOnInit() {}

  /**
   * Valide le format d'une adresse email
   */
  isValidEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }

}
